import { AuthCrudHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

/**rhybusAuthCrudHttp:
 * .
 */
export const rhybusAuthCrudHttp = () => {
  try {
    return new AuthCrudHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint AuthCrudHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)
    throw error
  }
}
